<template>
  <div class="ai-check-container">
    <!-- Header Banner -->
    <div class="ai-header-banner">
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <div class="banner-left">
          <div class="ai-icon-pulse">
            <i class="el-icon-odometer"></i>
          </div>
          <div>
            <h1 class="banner-title">BỘ ĐẾM GIAO DỊCH HỆ THỐNG</h1>
            <p class="banner-subtitle">Đối chiếu tổng số giao dịch đã nhận giữa cổng thanh toán SePay và hệ thống quản lý trường học OneKids.</p>
          </div>
        </div>
        <div class="banner-actions">
          <el-button type="success" class="gradient-btn green-btn" icon="el-icon-download" @click="handleExportExcel">
            Xuất Excel đối soát
          </el-button>
        </div>
      </div>
    </div>

    <!-- Quick Stats Grid -->
    <div class="ai-stats-grid">
      <div class="stat-card blue">
        <div class="stat-icon"><i class="el-icon-refresh-left"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng giao dịch trên SePay (Trang này)</p>
          <h3 class="stat-value">{{ stats.sepayCount }}</h3>
        </div>
      </div>
      <div class="stat-card green">
        <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
        <div class="stat-info">
          <p class="stat-label">Tổng giao dịch trên OneKids (Trang này)</p>
          <h3 class="stat-value">{{ stats.onekidsCount }}</h3>
        </div>
      </div>
      <div class="stat-card purple">
        <div class="stat-icon"><i class="el-icon-document-copy"></i></div>
        <div class="stat-info">
          <p class="stat-label">Lệch giao dịch (Đối chiếu)</p>
          <h3 class="stat-value" :class="stats.diffCount !== 0 ? 'diff-warning' : ''">
            {{ stats.diffCount }} GD
          </h3>
        </div>
      </div>
    </div>

    <!-- Filter Section -->
    <div class="glass-card mb-4">
      <el-form :inline="true" :model="dataFilter" class="modern-filter-form">
        <el-form-item label="Khoảng ngày đối soát">
          <el-date-picker
            v-model="times"
            type="daterange"
            format="dd-MM-yyyy"
            unlink-panels
            :clearable="false"
            range-separator="-"
            start-placeholder="Bắt đầu"
            end-placeholder="Kết thúc"
            class="modern-date-picker"
            @change="findAllData"
          />
        </el-form-item>

        <el-form-item class="filter-actions">
          <el-button type="primary" icon="el-icon-search" @click="findAllData">Lọc dữ liệu</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- Table Section -->
    <div class="glass-card table-container">
      <el-table
        ref="multipleTable"
        :data="dataTable"
        v-loading="loading.table"
        element-loading-text="Đang tải danh sách bộ đếm..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255,255,255,0.7)"
        class="modern-table"
        border
        highlight-current-row
        @selection-change="handleSelectionChange"
        :max-height="tableMaxHeight"
        :summary-method="getSummaries"
        show-summary
      >
        <el-table-column type="selection" width="55" align="center" />
        
        <el-table-column type="index" label="STT" width="60" align="center" />

        <el-table-column label="Ngày đối soát" min-width="160" align="center" prop="date" fixed>
          <template slot-scope="{ row }">
            <span class="date-text">{{ formatDate(row.date) }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tổng giao dịch vào (SePay)" min-width="200" align="center" prop="transactionIn">
          <template slot-scope="{ row }">
            <span class="count-badge green">{{ row.transactionIn || 0 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tổng giao dịch ra (SePay)" min-width="200" align="center" prop="transactionOut">
          <template slot-scope="{ row }">
            <span class="count-badge red">{{ row.transactionOut || 0 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tổng số giao dịch (SePay)" min-width="200" align="center" prop="transaction">
          <template slot-scope="{ row }">
            <span class="count-badge total">{{ row.transaction || 0 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tổng giao dịch vào (OneKids)" min-width="200" align="center" prop="transactionInOgv">
          <template slot-scope="{ row }">
            <span class="count-badge green-light">{{ row.transactionInOgv || 0 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tổng giao dịch ra (OneKids)" min-width="200" align="center" prop="transactionOutOgv">
          <template slot-scope="{ row }">
            <span class="count-badge red-light">{{ row.transactionOutOgv || 0 }}</span>
          </template>
        </el-table-column>

        <el-table-column label="Tổng số giao dịch (OneKids)" min-width="200" align="center" prop="transactionOgv">
          <template slot-scope="{ row }">
            <span class="count-badge total-light">{{ row.transactionOgv || 0 }}</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- Pagination controls -->
      <div class="pagination-wrapper mt-3 flex justify-center">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentPageChange"
          :current-page.sync="dataFilter.page"
          :page-sizes="listSizePage"
          :page-size="dataFilter.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import sePayConnectionService from "@/services/SePayConnectionService";
import { exportExcelTransactionCountAdmin } from "@/commonFuncion/ExportExcelTransactionCountAdmin";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "TransactionCounterAdmin",
  data() {
    return {
      times: [],
      dataFilter: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        page: 1,
        limit: 50
      },
      listSizePage: [50, 100, 200, 500, 1000],
      totalPage: 0,
      dataTable: [],
      listData: [],
      loading: {
        table: false
      },
      exportToExcelData: {
        titleFile: "THỐNG KÊ BỘ ĐẾM GIAO DỊCH",
        columnWidths: [10, 30, 50, 50, 50, 50, 50, 50],
        nameFile: "Thong_ke_bo_dem_giao_dich_" + moment().format("DD-MM-YYYY_hh-mm-ss")
      }
    };
  },

  computed: {
    tableMaxHeight() {
      return this.$tableMaxHeightCardManager || 750;
    },

    tableEmpty() {
      return this.$tableEmpty;
    },

    tableLoading() {
      return this.$tableLoading;
    },

    titleFileWithDateRange() {
      const start = moment(this.dataFilter.startDate).format("DD-MM-YYYY");
      const end = moment(this.dataFilter.endDate).format("DD-MM-YYYY");
      return `THỐNG KÊ BỘ ĐẾM GIAO DỊCH TỪ ${start} ĐẾN ${end}`;
    },

    completeExportToExcelData() {
      return {
        ...this.exportToExcelData,
        companyInfo: []
      };
    },

    stats() {
      let sepayCount = 0;
      let onekidsCount = 0;
      this.dataTable.forEach((x) => {
        sepayCount += Number(x.transaction) || 0;
        onekidsCount += Number(x.transactionOgv) || 0;
      });
      const diffCount = Math.abs(sepayCount - onekidsCount);
      return { sepayCount, onekidsCount, diffCount };
    }
  },

  async mounted() {
    const today = moment().format("YYYY-MM-DD");
    const tenDaysAgo = moment().subtract(10, "days").format("YYYY-MM-DD");
    this.dataFilter.startDate = tenDaysAgo;
    this.dataFilter.endDate = today;
    this.times = [this.dataFilter.startDate, this.dataFilter.endDate];
    await this.findAllData();
  },

  methods: {
    exportExcelTransactionCountAdmin,
    formatDate(iso) {
      if (!iso) return "—";
      const d = new Date(iso);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
    },

    handleSelectionChange(value) {
      this.listData = [...value];
    },

    async findAllData() {
      this.loading.table = true;
      await this.getCounterForMerchant();
      this.dataFilter.startDate = moment(this.times[0]).format("YYYY-MM-DD");
      this.dataFilter.endDate = moment(this.times[1]).format("YYYY-MM-DD");
      try {
        const res = await sePayConnectionService.getCounterForAdmin(
          this.dataFilter.startDate,
          this.dataFilter.endDate,
          this.dataFilter.limit,
          this.dataFilter.page
        );
        this.dataTable = res.data.data || [];
        this.totalPage = res.data.total || 0;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading.table = false;
      }
    },

    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 2) {
          sums[index] = "Tổng cộng";
          return;
        }
        if (index < 3) {
          sums[index] = "";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            return !isNaN(value) ? prev + value : prev;
          }, 0);
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },

    handleCommand(command) {
      if (command === "exportExcel") {
        this.handleExportExcel();
      }
    },

    async handleExportExcel() {
      const title = this.titleFileWithDateRange;
      const fileName = this.exportToExcelData.nameFile;
      this.exportToExcelData.titleFile = title;
      this.exportToExcelData.nameFile = fileName;
      if (this.listData.length > 0) {
        this.$confirm("Bạn có chắc chắn muốn xuất file hiện tại?", "Thông báo!", {
          confirmButtonText: "Có",
          cancelButtonText: "Không",
          type: "warning"
        }).then(async () => {
          await this.exportExcelTransactionCountAdmin(this.completeExportToExcelData, this.listData).then(() => {
            this.$message({
              message: "Xuất file thành công!",
              type: "success",
              duration: 5000
            });
          });
        });
      } else {
        NotifyMessage.leftCornerNotificationError("Không có dữ liệu được chọn!");
      }
    },

    async getCounterForMerchant() {
      if (this.times && this.times.length === 2) {
        this.dataFilter.startDate = moment(this.times[0]).format("YYYY-MM-DD");
        this.dataFilter.endDate = moment(this.times[1]).format("YYYY-MM-DD");
      }
      let data = {
        startDate: this.dataFilter.startDate,
        endDate: this.dataFilter.endDate
      };
      try {
        await sePayConnectionService.getCounterForMerchant(data);
      } catch (err) {
        console.error(err);
      }
    },

    handleSizeChange(value) {
      this.dataFilter.limit = value;
      this.dataFilter.page = 1;
      this.findAllData();
    },

    handleCurrentPageChange(value) {
      this.dataFilter.page = value;
      this.findAllData();
    }
  }
};
</script>

<style lang="scss" scoped>
.ai-check-container {
  padding: 16px;
  background-color: #f4f6fa;
  min-height: calc(100vh - 120px);
}

/* Header Banner Styling */
.ai-header-banner {
  position: relative;
  border-radius: 12px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 24px 32px;
  margin-bottom: 24px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(30, 60, 114, 0.15);

  .banner-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%);
  }

  .banner-content {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 1;
    width: 100%;
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .ai-icon-pulse {
    width: 60px;
    height: 60px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
    animation: iconPulse 3s infinite ease-in-out;

    i {
      font-size: 32px;
      color: #fff;
    }
  }

  .banner-title {
    color: #fff;
    font-size: 22px;
    margin: 0 0 6px 0;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .banner-subtitle {
    color: rgba(255, 255, 255, 0.85);
    font-size: 13px;
    margin: 0;
  }

  .gradient-btn {
    border: none;
    font-weight: 600;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-2px);
    }

    &.green-btn {
      background: linear-gradient(90deg, #10b981 0%, #059669 100%);
      box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3);
      &:hover { box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4); }
    }
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 15px rgba(255, 255, 255, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 25px rgba(255, 255, 255, 0.4);
  }
}

/* Stats Cards Grid */
.ai-stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  }

  .stat-icon {
    width: 48px;
    height: 48px;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
  }

  .stat-info {
    flex: 1;
  }

  .stat-label {
    margin: 0 0 4px 0;
    font-size: 13px;
    color: #64748b;
  }

  .stat-value {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    
    &.diff-warning {
      color: #ea580c;
    }
  }

  /* Colors */
  &.blue {
    border-left: 4px solid #3b82f6;
    .stat-icon { background: rgba(59, 130, 246, 0.1); color: #3b82f6; }
  }
  &.green {
    border-left: 4px solid #10b981;
    .stat-icon { background: rgba(16, 185, 129, 0.1); color: #10b981; }
  }
  &.purple {
    border-left: 4px solid #8b5cf6;
    .stat-icon { background: rgba(139, 92, 246, 0.1); color: #8b5cf6; }
  }
}

/* Glassmorphic Cards */
.glass-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.table-container {
  background: #fff;
  padding: 12px;
}

/* Filter Forms */
.modern-filter-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;

  /deep/ .el-form-item {
    margin-bottom: 0 !important;
    margin-right: 0 !important;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  .modern-date-picker {
    width: 250px;
  }
}

/* Modern Table Styles */
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  /deep/ th {
    background-color: #f8fafc !important;
    color: #475569;
    font-weight: 600;
    height: 48px;
  }

  /deep/ td {
    padding: 10px 0;
  }

  /deep/ .el-table__footer-wrapper tbody td.el-table__cell,
  /deep/ .el-table__fixed-footer-wrapper tbody td.el-table__cell {
    font-weight: bold;
    background-color: #f8fafc;
    color: #1d4ed8;
  }
}

.date-text {
  font-family: Consolas, Monaco, monospace;
  font-weight: 700;
  color: #1e293b;
  font-size: 13px;
}

/* Badges for counts */
.count-badge {
  font-family: Consolas, Monaco, monospace;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 13px;

  &.green { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }
  &.red { background: #fef2f2; color: #991b1b; border: 1px solid #fecaca; }
  &.total { background: #eff6ff; color: #1d4ed8; border: 1px solid #dbeafe; }

  &.green-light { background: #f0fdf4; color: #15803d; }
  &.red-light { background: #fef2f2; color: #b91c1c; }
  &.total-light { background: #eff6ff; color: #2563eb; }
}

.pagination-wrapper {
  margin-top: 16px;
  display: flex;
  justify-content: center;
}

.mb-4 { margin-bottom: 16px; }
.flex { display: flex; }
.justify-center { justify-content: center; }
</style>